const _ = require("lodash");
class CombineRecords {

    /**
     * 
     * @param {array} cleanRecords (Static from Loanplaz)
     * @param {array} plaidRecords (Linked from Plaid)
     * @param {string} type ('account' or 'loan')
     */
    constructor(cleanRecords, plaidRecords, type) {
        this.cleanRecords = cleanRecords;
        this.plaidRecords = plaidRecords;
        this.type = type;
    }

    cleanPlaidAccountRecords() {
        let clean = [];
        if (this.plaidRecords.length) {
            this.plaidRecords.map((account) => {
                return clean.push({
                    balance: account.balances.current,
                    name: account.institution.name + ' ' + (account.official_name ? account.official_name : ''),
                    color: account.institution.primary_color,
                    id: account.account_id,
                    type: [account.subtype]
                });
            });
        }
        return clean;
    }

    cleanPlaidLoanRecords() {
        let clean = [];
        if (this.plaidRecords.length) {
            this.plaidRecords.map((loan) => {
                return clean.push({
                    id: loan.account_id,
                    type: loan.type,
                    name: loan.institution.name + ' ' + loan.official_name,
                    lenderName: loan.institution.name + ' ' + loan.official_name,
                    term: 36,
                    originalLoanAmount: loan.balances.limit,
                    currentBalance: loan.balances.current,
                    interest: 21.21,
                    minMonthlyPayment: 0,
                    startDate: Math.floor(new Date().getTime() / 1000)

                });
            });
        }
        return clean;
    }

    getCombinedRecoreds() {
        let cleanPlaid = [];
        let cleanRecords = this.cleanRecords;

        if (this.type === 'account') {
            cleanPlaid = this.cleanPlaidAccountRecords();
        } else if (this.type === 'loan') {
            cleanPlaid = this.cleanPlaidLoanRecords();
        }
        let data = _.unionBy(cleanRecords, cleanPlaid, "id");
        return data;
        //return cleanRecords.concat(cleanPlaid);
    }

}

module.exports = CombineRecords;
